module.exports = "<div>\n  <div class=\"loading\">\n    <div style=\"height:30px;margin-top:50px;color:black;margin-bottom:100px;\">\n      <img src=\"assets/loading.svg\" alt=\"loading\" style=\"height:28px;width:28px;margin-right:5px;display:inline-block;\"><span> Loading...</span>\n    </div>    \n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callback.component.html
// module id = ./src/app/callback/callback.component.html
// module chunks = main